import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import PageWrapper from '../../components/PageWrapper'
import BorderButton from '../../components/BorderButton'
import { Preloader } from '../../components/Chart/index'
import WhiteBox from '../../components/WhiteBox'

import { getAudiencePrefix } from '../../lib/get-audience-prefix'
import CookieTypes from '../../components/CookieTypes'
import PartnerTypes from '../../components/PartnerTypes'
import ReactTooltip from 'react-tooltip'

import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import { countryToFlag } from '../../lib/format-dmps'
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { countries } from '../../lib/countries'


//import './styles.css'
import 'react-bootstrap-toggle/dist/bootstrap2-toggle.css'
import { Bootstrap2Toggle } from 'react-bootstrap-toggle'

import axios from 'axios'


const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;


const Selector = ({ variants, selected, onChangeSelection }) => {
    const clazz = page => (selected === page ? 'selected' : '')
    return (
        <div>
            {variants.map(variant => (
                <span key={variant} className={`segment-list segment-list--selector ${clazz(variant)}`} onClick={() => onChangeSelection(variant)}>
                    verticals
                </span>
            ))}
        </div>
    )
}

class NewPartner extends Component {
    state = {

        friendlyName: "New partner name",
        partnerType: "DATA_PROVIDER",
        cookieTypes: "ar",
        maxAudiences: 10000,
        maxLicenses: 10000,
        maxUploadsDaily: 400,
        pricingType: 'revshare',
        partnerAlias: null,
        gdprConfirm: true,
        canEdit: true,
        canCreateChildren: false,
        region: "us",

        marketerMaxCompositeSize: 1000000000,
        marketerRevshare: 10.0,
        marketerOnTopRevshare: 15.0,
        marketerCountriesSelected: [],
        marketerPartnerSelected: [],
        canEditCompositeAudiencesCpm: false, 



    }

    componentDidMount() {

        // load countries list 
        this.setState({
            countries: countries
                .filter(c => c.hasOwnProperty('iso2Code'))
                .sort((a, b) => {
                    var keyA = a.name,
                        keyB = b.name
                    if (keyA < keyB) return -1
                    if (keyA > keyB) return 1
                    return 0
                }),
        })

        // load partner lists
        axios.get('/partner?offset=0&size=10000&filter=').then(response => {
            console.log('get partner ', response.data)

            let data = response.data.body[0] || {}
            let subPartnerSettings = data.subPartnerSettings || []
            subPartnerSettings = [{"partnerId": "p-admin", "friendlyName": "Audiencerate"}].concat(subPartnerSettings)

            this.setState({
                partners: subPartnerSettings,
            }, () => {
                
                
            })
        })


    }

    onSubPartnersSave() {
        console.log('onSubPartnersSave ', this, this.state)

        //console.log("marketerCountriesSelected", this.state.marketerCountriesSelected)
        //return

        // new | edit
        let method = 'POST'
        let data = {
            friendlyName: this.state.friendlyName,
            canCreateChildren: this.state.canCreateChildren ? 1 : 0,
            canEdit: this.state.canEdit ? 1 : 0,
            gdprConfirm: this.state.gdprConfirm ? 1 : 0,
            region: this.state.region,
            partnerType: this.state.partnerType,
            cookieTypes: this.state.cookieTypes,
            partnerAlias: this.state.partnerAlias,
            maxAudiences: this.state.maxAudiences,
            maxLicenses: this.state.maxLicenses,
            maxUploadsDaily: this.state.maxUploadsDaily,
            pricingType: this.state.pricingType,

            marketerMaxCompositeSize: parseInt(this.state.marketerMaxCompositeSize),
            marketerRevshare: this.state.marketerRevshare,
            marketerRevshareOnTop: this.state.marketerOnTopRevshare,
            marketerCountriesVisibility: this.state.marketerCountriesSelected.map(el => el.iso2Code).join(","),
            marketerPartnerSelected : this.state.marketerPartnerSelected.map(el => el.partnerId).join(","),
            canEditCompositeAudiencesCpm: this.state.canEditCompositeAudiencesCpm ? 1 : 0,

        }


        this.setState({ loading: true }, () => {
            axios
                .request({
                    url: '/partner',
                    method: method,
                    data: data
                })
                .then(response => {
                    console.log('onSubPartnersRemove response', response)
                    this.setState({ loading: false })
                    window.location.href = '/settings'
                })
        })
    }


    render() {
        const { name } = this.state
        const { segments, loading, hasMore } = this.props
        return (
            <PageWrapper>
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-10">
                            <WhiteBox>
                                <div
                                    style={{
                                        position: 'relative',
                                        paddingRight: 100
                                    }}>
                                    <div className="row">
                                        <div className="col-3">
                                            <img src="/img/audience/illy-segment-based-audience.svg" alt="" />
                                        </div>
                                        <div className="col-9">
                                            <h3 style={{ marginTop: 26 }}>NEW PARTNER</h3>



                                            {/*
                                            <div className="row">
                                                <div className="col-12">
                                                    <p style={{ marginTop: 30 }}>Partner ID *</p>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={name}
                                                        disabled={true}
                                                    />
                                                    <font style={{ fontSize: '13px', color: '#888' }}>This will be generated after save.</font>
                                                    
                                                </div>
                                               
                                            </div>
*/}

                                            <div className="row">
                                                <div className="col">
                                                    <p style={{ marginTop: 30 }}>Friendly name</p>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.friendlyName}
                                                        onChange={({ target }) => this.setState({ friendlyName: target.value })}
                                                    />
                                                </div>
                                                <div className="col">
                                                    <p style={{ marginTop: 30 }}>Region</p>
                                                    <select className="form-control" id="region" onChange={event => this.setState({ region: event.target.value })}>
                                                        <option key="us" value="us">
                                                            United States
                                                </option>
                                                        <option key="eu" value="eu">
                                                            Europe
                                                </option>
                                                    </select>

                                                </div>
                                            </div>



                                            <p style={{ marginTop: 30 }}>Partner Type</p>
                                            <PartnerTypes
                                                partnerTypes={this.state.partnerType ? this.state.partnerType.split(",") : []}
                                                onPartnerTypeChange={(partnerTypes) => {
                                                    console.log('partner types change update', partnerTypes)
                                                    this.setState({ partnerType: partnerTypes.join(",") })
                                                }} />

                                            <p style={{ marginTop: 30 }}>Cookie Types</p>
                                            <CookieTypes
                                                cookieTypes={this.state.cookieTypes ? this.state.cookieTypes.split(",") : []}
                                                onCookieTypeChange={(cookieTypes) => {
                                                    console.log('cookie types change update', cookieTypes)
                                                    this.setState({ cookieTypes: cookieTypes.join(",") })
                                                }} />

                                            <br />

                                            {this.state.partnerType && this.state.partnerType.indexOf("MARKETER") !== -1 && (
                                                <div style={{
                                                    'border': '1px solid rgb(221, 221, 221)',
                                                    'padding': '20px'
                                                }}>
                                                    <h3>Marketer Settings</h3>

                                                    <div className="row">
                                                        <div className="col">
                                                            <p style={{ marginTop: 30 }}>Revenue share %</p>
                                                            <input
                                                                type="number"
                                                                min="0.0"
                                                                className="form-control"
                                                                value={this.state.marketerRevshare}
                                                                onChange={({ target }) => this.setState({ marketerRevshare: target.value })}
                                                            />
                                                            <font style={{ fontSize: '13px', color: '#888' }}>% applied for a marketer revenue share %.</font>

                                                        </div>
                                                        <div className="col">
                                                            <p style={{ marginTop: 30 }}>On top revenue share %</p>
                                                            <input
                                                                type="number"
                                                                min="0.0"
                                                                className="form-control"
                                                                value={this.state.marketerOnTopRevshare}
                                                                onChange={({ target }) => this.setState({ marketerOnTopRevshare: target.value })}
                                                            />
                                                            <font style={{ fontSize: '13px', color: '#888' }}>Marketer's on top premium revenue share %.</font>

                                                        </div>
                                                        {/* Max size of the composite generated in the marketplace. */}
                                                        <div className="col">
                                                            <p style={{ marginTop: 30 }}>Max composite size</p>
                                                            <input
                                                                type="number"
                                                                min="0.0"
                                                                className="form-control"
                                                                value={this.state.marketerMaxCompositeSize}
                                                                onChange={({ target }) => this.setState({ marketerMaxCompositeSize: target.value })}
                                                            />
                                                            <font style={{ fontSize: '13px', color: '#888' }}>Marketer's max composite size permitted.</font>

                                                        </div>

                                                        <div className="col">
                                                            <p style={{ marginTop: 30 }}>Can Edit CPM on Composite Audiences</p>
                                                            <p style={{ 'margin': 0 }}>
                                                                <Bootstrap2Toggle
                                                                    onClick={value => {
                                                                        this.setState({ canEditCompositeAudiencesCpm: value })
                                                                    }}
                                                                    on={<span>ON</span>}
                                                                    off={<span>OFF</span>}
                                                                    size="xs"
                                                                    offstyle="secondary"
                                                                    active={this.state.canEditCompositeAudiencesCpm}
                                                                />
                                                            </p>
                                                            <font style={{ fontSize: '13px', color: '#888' }}>Toggle if the Partner has editing cababilities when creating a new Composite and related CMP.</font>

                                                        </div>
                                                        
                                                    </div>
                                                    <div className="row">
                                                        <div className="col">
                                                            <p style={{ marginTop: 30 }}>Countries Visibility</p>
                                                            <Autocomplete
                                                                id="country-select"
                                                                options={this.state.countries}
                                                                autoHighlight
                                                                multiple
                                                                limitTags={1}
                                                                disableCloseOnSelect
                                                                getOptionLabel={option => option.name}
                                                                onChange={(event, newValue) => {
                                                                    if (newValue) {
                                                                        console.log('country change ', newValue)
                                                                        //let marketerCountriesSelected = newValue.map(el => el.iso2Code)
                                                                        let marketerCountriesSelected = newValue
                                                                        this.setState({ marketerCountriesSelected: marketerCountriesSelected })
                                                                    }
                                                                }}
                                                                renderOption={(option, { selected }) => (
                                                                    <React.Fragment>
                                                                        <Checkbox
                                                                            color="primary"
                                                                            icon={icon}
                                                                            checkedIcon={checkedIcon}
                                                                            style={{ marginRight: 8 }}
                                                                            checked={selected}
                                                                        />
                                                                        <span>{countryToFlag(option.iso2Code)}</span>&#160;{option.name}
                                                                    </React.Fragment>
                                                                )}
                                                                renderInput={params => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Choose a country"
                                                                        variant="outlined"
                                                                        inputProps={{
                                                                            ...params.inputProps,
                                                                            autoComplete: 'new-password', // disable autocomplete and autofill
                                                                            form: {
                                                                                autocomplete: 'off'
                                                                            }
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                            <font style={{ fontSize: '13px', color: '#888' }}>Limit what countries this marketer can see in the Marketer platform. <u><b>Leave this field blank if you want to enable all countries.</b></u></font>


                                                        </div>

                                                    </div>
                                                    
                                                    <div className="row">
                                                        <div className="col">
                                                            <p style={{ marginTop: 30 }}>Partners Visibility</p>
                                                            <Autocomplete
                                                                id="partners-select"
                                                                options={this.state.partners}
                                                                autoHighlight
                                                                multiple
                                                                limitTags={1}
                                                                disableCloseOnSelect
                                                                getOptionLabel={option => option.friendlyName}
                                                                onChange={(event, newValue) => {
                                                                    if (newValue) {
                                                                        console.log('partner change ', newValue)
                                                                        //let marketerPartnerSelected = newValue.map(el => el.partnerId)
                                                                        let marketerPartnerSelected = newValue
                                                                        this.setState({ marketerPartnerSelected: marketerPartnerSelected })
                                                                    }
                                                                }}
                                                                renderOption={(option, { selected }) => (
                                                                    <React.Fragment>
                                                                        <Checkbox
                                                                            color="primary"
                                                                            icon={icon}
                                                                            checkedIcon={checkedIcon}
                                                                            style={{ marginRight: 8 }}
                                                                            checked={selected}
                                                                        />
                                                                        {option.friendlyName}
                                                                    </React.Fragment>
                                                                )}
                                                                renderInput={params => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Choose a partner"
                                                                        variant="outlined"
                                                                        inputProps={{
                                                                            ...params.inputProps,
                                                                            autoComplete: 'new-password', // disable autocomplete and autofill
                                                                            form: {
                                                                                autocomplete: 'off'
                                                                            }
                                                                        }}
                                                                    />
                                                                )}
                                                            />
                                                            <font style={{ fontSize: '13px', color: '#888' }}>Limit what partners this marketer can see in the Marketer platform. <u><b>Leave this field blank if you want to enable all partners.</b></u></font>


                                                        </div>

                                                    </div>


                                                </div>
                                            )}



                                            <br />
                                            <h3>Limits</h3>


                                            <div className="row">
                                                <div className="col">
                                                    <p style={{ marginTop: 30 }}>Max Audiences</p>
                                                    <input
                                                        type="number"
                                                        min="0.0"
                                                        className="form-control"
                                                        value={this.state.maxAudiences}
                                                        onChange={({ target }) => this.setState({ maxAudiences: target.value })}
                                                    />
                                                    <font style={{ fontSize: '13px', color: '#888' }}>Limit how many can create per account.</font>

                                                </div>
                                                <div className="col">
                                                    <p style={{ marginTop: 30 }}>Max Licenses</p>
                                                    <input
                                                        type="number"
                                                        min="0.0"
                                                        className="form-control"
                                                        value={this.state.maxLicenses}
                                                        onChange={({ target }) => this.setState({ maxLicenses: target.value })}
                                                    />
                                                    <font style={{ fontSize: '13px', color: '#888' }}>Limit how many can create per account.</font>

                                                </div>
                                                <div className="col">
                                                    <p style={{ marginTop: 30 }}>Max Daily Imports</p>
                                                    <input
                                                        type="number"
                                                        min="0.0"
                                                        className="form-control"
                                                        value={this.state.maxUploadsDaily}
                                                        onChange={({ target }) => this.setState({ maxUploadsDaily: target.value })}
                                                    />
                                                    <font style={{ fontSize: '13px', color: '#888' }}>Limit how many uploads per day.</font>


                                                </div>

                                            </div>




                                            <br />
                                            <h3>Other Options</h3>

                                            <div className="row">
                                                <div className="col">
                                                    <p style={{ marginTop: 30 }}>Partner Alias</p>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={this.state.partnerAlias}
                                                        onChange={({ target }) => this.setState({ partnerAlias: target.value })}
                                                    />
                                                    <font style={{ fontSize: '13px', color: '#888' }}>This alias is used in the creation of audiences names instead of the Partner's Friendly name.</font>

                                                </div>
                                                <div className="col">

                                                    <p style={{ marginTop: 30 }}>Pricing Type</p>
                                                    <select className="form-control" onChange={event => this.setState({ pricingType: event.target.value })}>
                                                        <option key="revshare" value="revshare">
                                                            Revshare
                                                </option>
                                                        <option key="flat" value="flat">
                                                            Flat fee (Those partners doesn't have upload limits)
                                                </option>
                                                    </select>
                                                </div>
                                            </div>




                                            <div className="row">
                                                <div className="col">
                                                    <p style={{ marginTop: 30 }}>GDPR confirm</p>
                                                    <p style={{ 'margin': 0 }}>
                                                        <Bootstrap2Toggle
                                                            onClick={value => {
                                                                this.setState({ gdprConfirm: value })
                                                            }}
                                                            on={<span>ON</span>}
                                                            off={<span>OFF</span>}
                                                            size="xs"
                                                            offstyle="secondary"
                                                            active={this.state.gdprConfirm}
                                                        />
                                                    </p>
                                                    <font style={{ fontSize: '13px', color: '#888' }}>Toggle if the EU Partner has confirmed GDPR.</font>

                                                </div>
                                                <div className="col">

                                                    <p style={{ marginTop: 30 }}>Can Edit</p>
                                                    <p style={{ 'margin': 0 }}>
                                                        <Bootstrap2Toggle
                                                            onClick={value => {
                                                                this.setState({ canEdit: value })
                                                            }}
                                                            on={<span>ON</span>}
                                                            off={<span>OFF</span>}
                                                            size="xs"
                                                            offstyle="secondary"
                                                            active={this.state.canEdit}
                                                        />
                                                    </p>
                                                    <font style={{ fontSize: '13px', color: '#888' }}>Toggle if the Partner has editing cababilities in the UI.</font>

                                                </div>
                                                <div className="col">

                                                    <p style={{ marginTop: 30 }}>Can Create Sub-partners</p>
                                                    <p style={{ 'margin': 0 }}>
                                                        <Bootstrap2Toggle
                                                            onClick={value => {
                                                                console.log("bool ", value)
                                                                this.setState({ canCreateChildren: value })
                                                            }}
                                                            on={<span>ON</span>}
                                                            off={<span>OFF</span>}
                                                            size="xs"
                                                            offstyle="secondary"
                                                            active={this.state.canCreateChildren}
                                                        />
                                                    </p>
                                                    <font style={{ fontSize: '13px', color: '#888' }}>Toggle if the Partner can create sub partners under his account.</font>

                                                </div>

                                            </div>







                                            <div className="new-segment-based-audience new-segment-based-audience--button-group">
                                                <BorderButton className="grey" label="Cancel" onClick={() => window.location.href = '/settings'} />
                                                <BorderButton disabled={this.state.disableButton} label="SAVE" onClick={this.onSubPartnersSave.bind(this)} />
                                                {this.state.saving && <Preloader transparent />}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </WhiteBox>
                        </div>
                    </div>

                </div>
            </PageWrapper>
        )
    }
}

const mapDispatchToProps = dispatch => ({
    goBack: () => dispatch(push('/settings'))
})

const mapStateToProps = (state, { match }) => {
    return {


    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewPartner)
